<template>
    <el-dialog
        ref="DialogUser"
        v-model="visibled"
        :title="title"
        width="500"
        align-center
        draggable
        @closed="onClosed"
        @keyup.enter="doConfirm">
        <el-form
            ref="RuleFormRef"
            :model="data"
            :rules="rules"
            :hide-required-asterisk="true"
            :inline-message="true">
            <el-form-item label="账号" prop="username">
                <el-input
                    v-model="data.username"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input
                    v-model="data.password"
                    autocomplete="off"
                    :placeholder="is_new?'必填项':'选填项'"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input
                    v-model="data.email"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="电话" prop="us_phone_number">
                <el-input
                    v-model="data.us_phone_number"
                    autocomplete="off"
                    placeholder="选填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="客户" prop="corp_code">
                <el-select
                    v-model="data.corp_code"
                    autocomplete="off"
                    filterable
                    placeholder="选填项"
                    clearable
                    maxlength="32">
                    <el-option
                        v-for="item in options.corporations"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code" />
                </el-select>
            </el-form-item>
            <el-form-item label="角色" prop="roles">
                <el-select
                    v-model="data.roles"
                    multiple
                    filterable
                    placeholder="必填项">
                    <el-option
                        v-for="name in roles"
                        :key="name"
                        :label="name"
                        :value="name" />
                </el-select>
            </el-form-item>
            <el-form-item v-if="!is_new" label="状态" prop="active">
                <el-select
                    v-model="data.active"
                    placeholder="必填项">
                    <el-option label="活跃" value="true" />
                    <el-option label="冻结" value="false" />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="foot_div">
            <el-row>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        @click="visibled = false">
                        取消
                    </el-button>
                </el-col>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        :disabled="!validate"
                        type="primary"
                        @click="doConfirm">
                        保存
                    </el-button>
                </el-col>
                <el-col :span="4" />
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import {notify, dict, asleep} from '../../assets/js/utils.js';
export default {
    name: 'DialogUser',
    components: {
    },
    props: {
    },
    data() {
        return {
            visibled: false,
            resolve: null,
            reject: null,
            title: null,
            roles: ['user', 'admin'],
            list: [],
            data: {},
        };
    },
    computed: {
        validate() {
            return true;
        },
        is_new() {
            console.log(`is new ${!this.options.data.id}`);
            return !this.data.id;
        },
        rules() {
            // 重复检测
            const validate_duplicate = (rule, value, callback) => {
                const key = rule.field;
                if (this.list.some(x => x[key] === value && x.id !== this.data.id)) {
                    callback(new Error(rule.message ?? `${rule.field} was duplicate.`));
                } else {
                    callback();
                }
            };
            // 密码检测
            const validate_password = (rule, value, callback) => {
                if (value && value.length < rule.minsize || !value && this.is_new) {
                    callback(
                        new Error(rule.message
                            ?? `${rule.field} length need lg ${rule.minsize}`,
                        ));
                } else {
                    callback();
                }
            };
            // 字段检测规则;
            const rules = {
                username: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {validator: validate_duplicate, message: '帐号', trigger: ['change', 'blur']}],
                password: [{
                    required: true,
                    validator: validate_password,
                    minsize: 6,
                    message: '密码长度必须大于等于6',
                    trigger: ['change', 'blur'],
                }],
                email: [
                    {required: true, message: '请输入邮箱', trigger: ['change', 'blur']},
                    {validator: validate_duplicate, message: '邮箱重复', trigger: ['change', 'blur']},
                ],
                roles: [{required: true, message: '请添加角色', trigger: ['change', 'blur']}],
            };

            const rule_fields = {
                true: ['username', 'password', 'email', 'roles'],
                false: ['username', 'password', 'email', 'roles'],
            };
            return rule_fields[this.is_new].reduce((rs, k) => {
                rs[k] = rules[k];
                return rs;
            }, {});
        },
    },
    mounted() {
    },
    methods: {
        async show(options) {
            console.debug(options);
            this.options = options;
            this.visibled = true;
            this.title = options.title ?? options.data.id ? '修改' : '添加';
            this.list = options.list;
            Object.entries(this.data).forEach(([k, _]) => delete (this.data[k]));
            Object.entries(options.data).forEach(([k, v]) => {
                this.data[k] = typeof v === 'boolean' ? v.toString() : v;
            });
            this.data.password = null;
            (async () => {
                await asleep(100);
                this.$refs.RuleFormRef?.clearValidate();
            })();
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async doConfirm() {
            const form = this.$refs.RuleFormRef;
            try {
                await form.validate();
            } catch (e) {
                console.warn(e);
                notify('error', '填写错误！');
                return;
            }
            // 获取要提交的数据
            const fields = form.fields.map(x => x.prop);
            const empty = ['', null, undefined];
            const newdata = dict(Object.entries({
                ...this.data,
                ...{active: this.data.active === 'true'},
            })
                .filter(([k, v]) => empty.indexOf(v) < 0 && fields.indexOf(k) >= 0));
            // console.log('OLD:', olddata);
            // console.log('NEW:', newdata);
            const data = (() => {
                const olddata = {...this.options.data};
                // 添加不需要过滤
                if (!olddata.id) return newdata;
                // 修改过滤未修改参数
                return dict(Object.entries(newdata).filter(([k, v]) => Array.isArray(v)
                    ? JSON.stringify(olddata[k].sort()) !== JSON.stringify(v.sort())
                    : olddata[k] !== v));
            })();
            if (Object.entries(data).length) {
                console.debug('submit user data:', data);
                try {
                    const res = await this.axios.post(
                        `/admin/api/users/${this.data.id || ''}`,
                        {...data, id: this.data.id},
                        {headers: {'Content-Type': 'application/json'}},
                    );
                    if (res.data.error) {
                        notify('error', `${res.data.error} ${res.data?.message}`);
                        return;
                    }
                } catch (e) {
                    notify(e);
                    console.error(e);
                    return;
                }
                this.resolve(data);
                this.reject = null;
                this.visibled = false;
                notify('success', '提交成功！');
            } else {
                notify('warning', '无字段变化！');
            }
        },
        onClosed() {
            if (this.reject) {
                this.reject();
            }
        },
    },
};
</script>

<style>

</style>
